import { render, staticRenderFns } from "./MyStatus.vue?vue&type=template&id=52df2bae&"
import script from "./MyStatus.vue?vue&type=script&lang=js&"
export * from "./MyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QExpansionItem,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QExpansionItem,QCardSection})
